import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fad5fc21"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.5 4.5 6 8l3.5-3.5",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  class: "nge-hl-dots",
  role: "radiogroup",
  "aria-label": "Mark as"
}
const _hoisted_4 = ["aria-checked", "title", "aria-label", "onClick"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["title"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["title"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.5 7.5 6 4l3.5 3.5",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hl-title" }, "Highlight", -1 /* HOISTED */))
const _hoisted_12 = {
  key: 0,
  class: "nge-hl-how"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_14 = { class: "nge-hl-dim" }
const _hoisted_15 = {
  key: 1,
  class: "nge-hl-how"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "to the soma", -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "beyond", -1 /* HOISTED */))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", null, "Ctrl", -1 /* HOISTED */))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "to the soma", -1 /* HOISTED */))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "beyond", -1 /* HOISTED */))
const _hoisted_21 = {
  key: 2,
  class: "nge-hl-mec"
}
const _hoisted_22 = { class: "nge-hl-mec-head" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Lab marks", -1 /* HOISTED */))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hl-mec-sub" }, "axon first", -1 /* HOISTED */))
const _hoisted_25 = ["data-on"]
const _hoisted_26 = ["aria-checked"]
const _hoisted_27 = ["aria-checked"]
const _hoisted_28 = {
  class: "nge-hl-styles",
  role: "radiogroup",
  "aria-label": "Lab mark"
}
const _hoisted_29 = ["aria-checked", "title", "onClick", "onKeydown"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hl-swatch nge-hl-swatch--fixed" }, null, -1 /* HOISTED */))
const _hoisted_31 = ["aria-label"]
const _hoisted_32 = { class: "nge-hl-mec-hint" }
const _hoisted_33 = {
  key: 0,
  class: "nge-hl-mec-actions"
}
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 1,
  class: "nge-hl-mec-actions"
}
const _hoisted_36 = ["disabled", "title"]
const _hoisted_37 = {
  class: "nge-hl-styles",
  role: "radiogroup",
  "aria-label": "Mark as"
}
const _hoisted_38 = ["aria-checked", "onClick", "onKeydown"]
const _hoisted_39 = ["title"]
const _hoisted_40 = ["value", "aria-label", "onInput"]
const _hoisted_41 = ["title", "aria-label", "onClick"]
const _hoisted_42 = {
  key: 3,
  class: "nge-hl-add"
}
const _hoisted_43 = ["onKeydown"]
const _hoisted_44 = {
  key: 0,
  class: "nge-hl-add-error"
}
const _hoisted_45 = {
  key: 4,
  class: "nge-hl-next"
}
const _hoisted_46 = { class: "nge-hl-actions" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  key: 2,
  class: "nge-hl-step"
}
const _hoisted_49 = ["disabled"]
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  class: "nge-hl-width",
  title: "How far out from the middle of the branch the color reaches. Wider covers thick branches and their spines; narrower keeps the color off neighboring branches."
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Color reach", -1 /* HOISTED */))
const _hoisted_53 = ["value"]
const _hoisted_54 = { class: "nge-hl-width-val" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hl-unit" }, "µm", -1 /* HOISTED */))
const _hoisted_56 = {
  class: "nge-hl-show3d",
  title: "Dim turns the stretches you marked Checked a dim grey on the cell, so what is left to check stands out. With the Lantern on, they stay dim in its light too."
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "nge-hl-dim-label" }, "Checked", -1 /* HOISTED */))
const _hoisted_58 = ["data-on"]
const _hoisted_59 = ["aria-checked", "tabindex"]
const _hoisted_60 = ["aria-checked", "tabindex"]
const _hoisted_61 = {
  class: "nge-hl-show3d",
  title: "Hide takes your highlights out of view, in 2D and in 3D. Nothing is deleted. You can also hide one highlight from its own layer tab."
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "nge-hl-show3d-label" }, "Highlight", -1 /* HOISTED */))
const _hoisted_63 = ["data-on"]
const _hoisted_64 = ["aria-checked", "tabindex"]
const _hoisted_65 = ["aria-checked", "tabindex"]
const _hoisted_66 = { class: "nge-hl-status" }
const _hoisted_67 = {
  key: 1,
  class: "nge-hl-dim"
}
const _hoisted_68 = {
  key: 2,
  class: "nge-hl-stat"
}
const _hoisted_69 = { class: "nge-hl-count" }
const _hoisted_70 = ["aria-hidden"]
const _hoisted_71 = {
  key: 0,
  ref: "loaderEl",
  class: "nge-hl-loader"
}
const _hoisted_72 = {
  key: 1,
  class: "nge-hl-loader-label"
}
const _hoisted_73 = {
  key: 2,
  class: "nge-hl-branch"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hl-branch-label" }, "From here", -1 /* HOISTED */))
const _hoisted_75 = {
  key: 3,
  ref: "askEl",
  class: "nge-hl-ask",
  role: "status",
  title: "This cell's soma is not on record yet. Your click is kept as a point in a Soma layer, so you are asked once per cell."
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-hl-ask-gem",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("kbd", null, "Ctrl"),
  /*#__PURE__*/_createTextVNode(" + click the soma")
], -1 /* HOISTED */))
const _hoisted_78 = [
  _hoisted_76,
  _hoisted_77
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      ref: "panelEl",
      class: _normalizeClass(["nge-hl-panel", { 'nge-hl-panel--placed': $setup.pos, 'nge-hl-panel--dragging': $setup.dragging, 'nge-hl-panel--slim': $setup.slim }]),
      style: _normalizeStyle($setup.posStyle),
      role: "dialog",
      "aria-label": "Highlight mode"
    }, [
      _createCommentVNode(" Slim: one row. Drag it by any empty part. "),
      ($setup.slim)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "nge-hl-slim",
            title: "Drag to move",
            onMousedown: $setup.startDrag
          }, [
            _createElementVNode("button", {
              class: "nge-hl-caret",
              type: "button",
              title: "Open the full Highlight box",
              "aria-label": "Open the full Highlight box",
              onClick: _cache[0] || (_cache[0] = $event => ($setup.setSlim(false)))
            }, _hoisted_2),
            _createElementVNode("span", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.allStyles, (s) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: s.key,
                  type: "button",
                  role: "radio",
                  class: _normalizeClass(["nge-hl-dot", { 'nge-hl-dot--on': $setup.styleKey === s.key }]),
                  style: _normalizeStyle({ '--hl': s.color }),
                  "aria-checked": $setup.styleKey === s.key ? 'true' : 'false',
                  title: s.label,
                  "aria-label": s.label,
                  onClick: $event => ($setup.styleKey = s.key)
                }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_4))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            ($setup.first)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "nge-hl-btn nge-hl-btn--sm nge-hl-btn--armed",
                  type: "button",
                  disabled: $setup.busy,
                  onClick: $setup.cancelPick,
                  title: "Drop the start point you placed. Finished marks stay. (Esc)"
                }, "Cancel", 8 /* PROPS */, _hoisted_5))
              : ($setup.busy)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "nge-hl-btn nge-hl-btn--sm",
                    type: "button",
                    onClick: $setup.stopTracing,
                    title: "Stop waiting for this path. Nothing is marked."
                  }, "Stop"))
                : _createCommentVNode("v-if", true),
            ($setup.first && !$setup.busy && !$setup.branchWay && !$setup.labOn)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("button", {
                    class: "nge-hl-btn nge-hl-btn--sm",
                    type: "button",
                    title: "Mark the way from this point back to the soma.",
                    onClick: _cache[1] || (_cache[1] = $event => ($setup.markBranch('toward')))
                  }, "To soma"),
                  _createElementVNode("button", {
                    class: "nge-hl-btn nge-hl-btn--sm",
                    type: "button",
                    title: "Mark every branch beyond this point, away from the soma. Where two cells are wrongly joined, the other cell can be marked too.",
                    onClick: _cache[2] || (_cache[2] = $event => ($setup.markBranch('away')))
                  }, "Beyond")
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("span", {
              class: _normalizeClass(["nge-hl-slim-step", { 'nge-hl-bad': $setup.messageBad }]),
              title: $setup.slimStep
            }, _toDisplayString($setup.busy ? 'Tracing' : $setup.slimStep), 11 /* TEXT, CLASS, PROPS */, _hoisted_6),
            _createElementVNode("button", {
              class: "nge-hl-btn nge-hl-btn--sm",
              type: "button",
              disabled: $setup.busy || (!$setup.markCount && !$setup.handCount && !$setup.first),
              onClick: $setup.undo
            }, "Undo", 8 /* PROPS */, _hoisted_7),
            _createElementVNode("span", {
              class: "nge-hl-count",
              title: `${$setup.markCount} ${$setup.markCount === 1 ? 'mark' : 'marks'}`
            }, _toDisplayString($setup.markCount), 9 /* TEXT, PROPS */, _hoisted_8),
            _createElementVNode("button", {
              class: "nge-hl-close",
              type: "button",
              "aria-label": "Close",
              onClick: _cache[3] || (_cache[3] = $event => ($setup.emit('hide')))
            }, "×")
          ], 32 /* HYDRATE_EVENTS */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", {
              class: "nge-hl-head",
              title: "Drag to move",
              onMousedown: $setup.startDrag
            }, [
              _createCommentVNode(" The slim button stays at the left, where it is in the slim strip (toknow, report 283). "),
              _createElementVNode("button", {
                class: "nge-hl-caret",
                type: "button",
                title: "Shrink to a slim strip",
                "aria-label": "Shrink to a slim strip",
                onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                onClick: _cache[5] || (_cache[5] = $event => ($setup.setSlim(true)))
              }, _hoisted_10, 32 /* HYDRATE_EVENTS */),
              _hoisted_11,
              _createElementVNode("button", {
                class: "nge-hl-close",
                "aria-label": "Close",
                onClick: _cache[6] || (_cache[6] = $event => ($setup.emit('hide')))
              }, "×")
            ], 32 /* HYDRATE_EVENTS */),
            ($setup.mec)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                  _createTextVNode(" Pick a lab mark, then " + _toDisplayString($setup.isTouchRef ? 'tap' : 'Ctrl + click') + " the cell to drop it. ", 1 /* TEXT */),
                  ($setup.noTrace)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Or pick a highlight color to mark a spot."),
                        _hoisted_13,
                        _createElementVNode("span", _hoisted_14, _toDisplayString($setup.noTrace), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("Or pick a highlight color and mark a checked stretch.")
                      ], 64 /* STABLE_FRAGMENT */))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_15, [
                  ($setup.isTouchRef)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" Tap where a checked stretch starts, then where it ends. After the first tap you can also mark "),
                        _hoisted_16,
                        _createTextVNode(" or "),
                        _hoisted_17,
                        _createTextVNode(". ")
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_18,
                        _createTextVNode(" + click where a checked stretch starts, then where it ends. After the first click you can also mark "),
                        _hoisted_19,
                        _createTextVNode(" or "),
                        _hoisted_20,
                        _createTextVNode(". ")
                      ], 64 /* STABLE_FRAGMENT */))
                ])),
            ($setup.mec)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _hoisted_24,
                    (!$setup.noTrace)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "nge-hl-switch nge-hl-mec-as",
                          role: "radiogroup",
                          "aria-label": "Lab marks as",
                          "data-on": $setup.labAs === 'point' ? 'show' : 'hide',
                          title: "Point: one click drops the lab's mark. Stretch: highlight a stretch in the mark's color, and its end gets the mark."
                        }, [
                          _createElementVNode("button", {
                            type: "button",
                            role: "radio",
                            "aria-checked": $setup.labAs === 'point' ? 'true' : 'false',
                            class: "nge-hl-switch-opt",
                            onClick: _cache[7] || (_cache[7] = $event => ($setup.setLabAs('point')))
                          }, "Point", 8 /* PROPS */, _hoisted_26),
                          _createElementVNode("button", {
                            type: "button",
                            role: "radio",
                            "aria-checked": $setup.labAs === 'stretch' ? 'true' : 'false',
                            class: "nge-hl-switch-opt",
                            onClick: _cache[8] || (_cache[8] = $event => ($setup.setLabAs('stretch')))
                          }, "Stretch", 8 /* PROPS */, _hoisted_27)
                        ], 8 /* PROPS */, _hoisted_25))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.labStyles, (s) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: s.key,
                        role: "radio",
                        tabindex: "0",
                        "aria-checked": $setup.styleKey === s.key ? 'true' : 'false',
                        class: _normalizeClass(["nge-hl-style", { 'nge-hl-style--on': $setup.styleKey === s.key }]),
                        style: _normalizeStyle({ '--hl': s.color }),
                        title: $setup.hintOf(s.key),
                        onClick: $event => ($setup.styleKey = s.key),
                        onKeydown: [
                          _withKeys(_withModifiers($event => ($setup.styleKey = s.key), ["prevent"]), ["enter"]),
                          _withKeys(_withModifiers($event => ($setup.styleKey = s.key), ["prevent"]), ["space"])
                        ]
                      }, [
                        _hoisted_30,
                        _createTextVNode(" " + _toDisplayString(s.label) + " ", 1 /* TEXT */),
                        _createElementVNode("span", {
                          class: "nge-hl-mec-n",
                          "aria-label": `${$setup.labCounts[s.key] ?? 0} placed`
                        }, _toDisplayString($setup.labCounts[s.key] ?? 0), 9 /* TEXT, PROPS */, _hoisted_31)
                      ], 46 /* CLASS, STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_29))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _createElementVNode("p", _hoisted_32, _toDisplayString($setup.noTrace && !$setup.picked().lab ? 'A highlight color is picked: one click marks a spot.' : $setup.labOn && $setup.styleKey === 'mec:soma' && $setup.somaAt ? `Soma at ${$setup.somaAt.join(', ')}. Click again to move it.` : $setup.labOn ? $setup.hintOf($setup.styleKey) : $setup.stretchKind() ? `${$setup.hintOf($setup.styleKey)} Click where the stretch starts, then its end: the end gets the mark.` : 'A highlight color is picked: clicks mark a stretch.'), 1 /* TEXT */),
                  ($setup.styleKey === 'mec:soma' && $setup.startAt)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("button", {
                          class: "nge-hl-btn",
                          type: "button",
                          title: "Move the view to the cell's starting point, to see it is in the soma.",
                          onClick: $setup.lookAtStart
                        }, "Go to the starting point"),
                        _createElementVNode("button", {
                          class: "nge-hl-btn nge-hl-btn--ok",
                          type: "button",
                          disabled: $setup.busy,
                          title: "Put the Soma mark where the crosshairs are. Go to the starting point first to use the nucleus.",
                          onClick: $setup.confirmSoma
                        }, _toDisplayString($setup.somaAt ? 'Move soma here' : 'Confirm soma here'), 9 /* TEXT, PROPS */, _hoisted_34)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        (!$setup.noTrace)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "nge-hl-btn",
                              type: "button",
                              disabled: $setup.busy || !$setup.labCounts['mec:ais'],
                              onClick: $setup.colourAxon,
                              title: $setup.labCounts['mec:ais'] ? 'Color everything beyond the AIS, away from the soma: the axon.' : 'Mark the AIS first: the axon is everything beyond it.'
                            }, "Color the axon", 8 /* PROPS */, _hoisted_36))
                          : _createCommentVNode("v-if", true)
                      ]))
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.styles, (s) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: s.key,
                  role: "radio",
                  tabindex: "0",
                  "aria-checked": $setup.styleKey === s.key ? 'true' : 'false',
                  class: _normalizeClass(["nge-hl-style", { 'nge-hl-style--on': $setup.styleKey === s.key }]),
                  style: _normalizeStyle({ '--hl': s.color }),
                  onClick: $event => ($setup.styleKey = s.key),
                  onKeydown: [
                    _withKeys(_withModifiers($event => ($setup.styleKey = s.key), ["prevent"]), ["enter"]),
                    _withKeys(_withModifiers($event => ($setup.styleKey = s.key), ["prevent"]), ["space"])
                  ]
                }, [
                  _createElementVNode("label", {
                    class: "nge-hl-swatch",
                    title: `Change the color of ${s.label}`,
                    onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("input", {
                      type: "color",
                      value: s.color,
                      "aria-label": `Color of ${s.label}`,
                      onInput: $event => ($setup.setColor(s, $event))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_40)
                  ], 8 /* PROPS */, _hoisted_39),
                  _createTextVNode(" " + _toDisplayString(s.label) + " ", 1 /* TEXT */),
                  ($setup.isCustom(s) && $setup.styleKey === s.key)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nge-hl-style-x",
                        type: "button",
                        title: `Remove ${s.label} from your colors (marks already made stay)`,
                        "aria-label": `Remove ${s.label}`,
                        onClick: _withModifiers($event => ($setup.removeStyle(s)), ["stop"])
                      }, "×", 8 /* PROPS */, _hoisted_41))
                    : _createCommentVNode("v-if", true)
                ], 46 /* CLASS, STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_38))
              }), 128 /* KEYED_FRAGMENT */)),
              (!$setup.adding && $setup.styles.length < $setup.MAX_HIGHLIGHT_STYLES)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "nge-hl-style nge-hl-style--add",
                    type: "button",
                    title: "Add a color of your own",
                    onClick: $setup.startAdding
                  }, "+ Add"))
                : _createCommentVNode("v-if", true)
            ]),
            ($setup.adding)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createElementVNode("label", {
                    class: "nge-hl-swatch nge-hl-swatch--big",
                    style: _normalizeStyle({ '--hl': $setup.newColor }),
                    title: "Pick the color"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "color",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.newColor) = $event)),
                      "aria-label": "New color"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, $setup.newColor]
                    ])
                  ], 4 /* STYLE */),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($setup.newName) = $event)),
                    class: "nge-hl-add-name",
                    type: "text",
                    maxlength: "24",
                    placeholder: "Name, e.g. Axon",
                    onKeydown: [
                      _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"])),
                      _withKeys(_withModifiers($setup.addStyle, ["prevent"]), ["enter"]),
                      _cache[13] || (_cache[13] = _withKeys(_withModifiers($event => ($setup.adding = false), ["prevent"]), ["esc"]))
                    ]
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_43), [
                    [_vModelText, $setup.newName]
                  ]),
                  _createElementVNode("button", {
                    class: "nge-hl-btn",
                    type: "button",
                    onClick: $setup.addStyle
                  }, "Add"),
                  _createElementVNode("button", {
                    class: "nge-hl-btn",
                    type: "button",
                    onClick: _cache[14] || (_cache[14] = $event => ($setup.adding = false))
                  }, "Cancel"),
                  ($setup.addError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString($setup.addError), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" One mark placed: say what comes next on a line of its own, and offer\n           the way back quietly (Ames 2026-10-27: \"click another spot to\n           highlight between\" and a less bold \"cancel this mark\"). "),
            ($setup.first)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString($setup.isTouchRef ? 'Tap' : 'Ctrl + click') + " another spot to highlight between", 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_46, [
              ($setup.first)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "nge-hl-btn nge-hl-btn--quiet",
                    disabled: $setup.busy,
                    onClick: $setup.cancelPick,
                    title: "Drop the start point you placed. Finished marks stay. (Esc)"
                  }, "Cancel this mark", 8 /* PROPS */, _hoisted_47))
                : ($setup.busy)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "nge-hl-btn nge-hl-btn--main",
                      onClick: $setup.stopTracing,
                      title: "Stop waiting for this path. Nothing is marked."
                    }, "Stop tracing"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString($setup.labOn ? `${$setup.isTouchRef ? 'Tap' : 'Ctrl + click'} to mark ${$setup.styleOf().label}` : $setup.isTouchRef ? 'Tap the start' : 'Ctrl + click the start'), 1 /* TEXT */)),
              _createElementVNode("button", {
                class: "nge-hl-btn",
                disabled: $setup.busy || (!$setup.markCount && !$setup.handCount && !$setup.first),
                onClick: $setup.undo
              }, "Undo", 8 /* PROPS */, _hoisted_49),
              _createElementVNode("button", {
                class: "nge-hl-btn",
                disabled: $setup.busy || !$setup.markCount,
                onClick: $setup.clearAll
              }, "Clear all", 8 /* PROPS */, _hoisted_50)
            ]),
            _createElementVNode("label", _hoisted_51, [
              _hoisted_52,
              _createElementVNode("input", {
                type: "range",
                min: "0.5",
                max: "8",
                step: "0.5",
                value: $setup.tintUm,
                onInput: $setup.onTintInput
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_53),
              _createElementVNode("span", _hoisted_54, [
                _createTextVNode(_toDisplayString($setup.tintUm) + " ", 1 /* TEXT */),
                _hoisted_55
              ])
            ]),
            _createCommentVNode(" Dim checked (Ames 2026-11-02: \"hide what's done\"): Checked stretches\n           go a dim grey on the cell, so what is left to check stands out. "),
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _createElementVNode("div", {
                class: "nge-hl-switch",
                role: "radiogroup",
                "aria-labelledby": "nge-hl-dim-label",
                "data-on": $setup.dimmed ? 'hide' : 'show'
              }, [
                _createElementVNode("button", {
                  type: "button",
                  role: "radio",
                  "aria-checked": $setup.dimmed ? 'false' : 'true',
                  tabindex: $setup.dimmed ? -1 : 0,
                  class: "nge-hl-switch-opt",
                  onClick: _cache[15] || (_cache[15] = $event => ($setup.setDimmed(false))),
                  onKeydown: [
                    _cache[16] || (_cache[16] = _withKeys(_withModifiers($event => ($setup.setDimmed(true)), ["prevent","stop"]), ["right"])),
                    _cache[17] || (_cache[17] = _withKeys(_withModifiers($event => ($setup.setDimmed(false)), ["prevent","stop"]), ["left"]))
                  ]
                }, "Color", 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_59),
                _createElementVNode("button", {
                  type: "button",
                  role: "radio",
                  "aria-checked": $setup.dimmed ? 'true' : 'false',
                  tabindex: $setup.dimmed ? 0 : -1,
                  class: "nge-hl-switch-opt nge-hl-switch-opt--hide",
                  onClick: _cache[18] || (_cache[18] = $event => ($setup.setDimmed(true))),
                  onKeydown: [
                    _cache[19] || (_cache[19] = _withKeys(_withModifiers($event => ($setup.setDimmed(true)), ["prevent","stop"]), ["right"])),
                    _cache[20] || (_cache[20] = _withKeys(_withModifiers($event => ($setup.setDimmed(false)), ["prevent","stop"]), ["left"]))
                  ]
                }, "Dim", 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_60)
              ], 8 /* PROPS */, _hoisted_58)
            ]),
            _createCommentVNode(" Show / Hide for every highlight at once, in 2D and 3D (Ames\n           2026-10-07: \"keep the hide/show highlight slider in highlight\").\n           The side that is lit is how things are now. "),
            _createElementVNode("div", _hoisted_61, [
              _hoisted_62,
              _createElementVNode("div", {
                class: "nge-hl-switch",
                role: "radiogroup",
                "aria-labelledby": "nge-hl-show3d-label",
                "data-on": $setup.shown ? 'show' : 'hide'
              }, [
                _createElementVNode("button", {
                  type: "button",
                  role: "radio",
                  "aria-checked": $setup.shown ? 'true' : 'false',
                  tabindex: $setup.shown ? 0 : -1,
                  class: "nge-hl-switch-opt",
                  onClick: _cache[21] || (_cache[21] = $event => ($setup.setShown(true))),
                  onKeydown: [
                    _cache[22] || (_cache[22] = _withKeys(_withModifiers($event => ($setup.setShown(false)), ["prevent","stop"]), ["right"])),
                    _cache[23] || (_cache[23] = _withKeys(_withModifiers($event => ($setup.setShown(true)), ["prevent","stop"]), ["left"]))
                  ]
                }, "Show", 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_64),
                _createElementVNode("button", {
                  type: "button",
                  role: "radio",
                  "aria-checked": $setup.shown ? 'false' : 'true',
                  tabindex: $setup.shown ? -1 : 0,
                  class: "nge-hl-switch-opt nge-hl-switch-opt--hide",
                  onClick: _cache[24] || (_cache[24] = $event => ($setup.setShown(false))),
                  onKeydown: [
                    _cache[25] || (_cache[25] = _withKeys(_withModifiers($event => ($setup.setShown(false)), ["prevent","stop"]), ["right"])),
                    _cache[26] || (_cache[26] = _withKeys(_withModifiers($event => ($setup.setShown(true)), ["prevent","stop"]), ["left"]))
                  ]
                }, "Hide", 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_65)
              ], 8 /* PROPS */, _hoisted_63)
            ]),
            _createCommentVNode(" The foot of the box reads like a stats line: what just happened, a\n           count or two, quietly (Ames 2026-10-02). "),
            _createElementVNode("div", _hoisted_66, [
              ($setup.message)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass({ 'nge-hl-bad': $setup.messageBad })
                  }, _toDisplayString($setup.message), 3 /* TEXT, CLASS */))
                : (!$setup.busy && !$setup.bandOn)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString($setup.branchWay ? '' : $setup.first ? 'Start placed. Ctrl + click another spot to highlight between.' : $setup.labOn ? 'One click drops the mark.' : 'No point placed yet.'), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
              ($setup.stat && !$setup.busy)
                ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString($setup.stat), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("span", _hoisted_69, _toDisplayString($setup.markCount) + " " + _toDisplayString($setup.markCount === 1 ? 'mark' : 'marks'), 1 /* TEXT */)
            ])
          ], 64 /* STABLE_FRAGMENT */)),
      _createCommentVNode(" The path search, as the bottom edge of the box, its label beside it. "),
      _createElementVNode("div", {
        class: _normalizeClass(["nge-hl-loader-wrap", { 'nge-hl-loader-wrap--on': $setup.bandOn, 'nge-hl-loader-wrap--done': $setup.bandDone }]),
        "aria-hidden": $setup.bandOn ? 'false' : 'true'
      }, [
        ($setup.bandOn)
          ? (_openBlock(), _createElementBlock("canvas", _hoisted_71, null, 512 /* NEED_PATCH */))
          : _createCommentVNode("v-if", true),
        ($setup.bandOn)
          ? (_openBlock(), _createElementBlock("span", _hoisted_72, [
              (!$setup.bandDone)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Tracing path "),
                    _createElementVNode("b", null, _toDisplayString($setup.traceSecs) + "s", 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Highlight complete")
                  ], 64 /* STABLE_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ], 10 /* CLASS, PROPS */, _hoisted_70),
      _createCommentVNode(" With one point placed: the way back to the soma, or everything\n           beyond the point (Krzysztof Kruk's idea, 2026-10-09). "),
      ($setup.first && !$setup.busy && !$setup.branchWay && !$setup.labOn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
            _hoisted_74,
            _createElementVNode("button", {
              class: "nge-hl-btn",
              type: "button",
              title: "Mark the way from this point back to the soma.",
              onClick: _cache[27] || (_cache[27] = $event => ($setup.markBranch('toward')))
            }, "To soma"),
            _createElementVNode("button", {
              class: "nge-hl-btn",
              type: "button",
              title: "Mark every branch beyond this point, away from the soma. Where two cells are wrongly joined, the other cell can be marked too.",
              onClick: _cache[28] || (_cache[28] = $event => ($setup.markBranch('away')))
            }, "Beyond")
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" The soma is not on record: one clear ask, lit as it arrives so the\n           eye goes to it (Ames 2026-10-10). "),
      ($setup.first && !$setup.busy && $setup.branchWay)
        ? (_openBlock(), _createElementBlock("div", _hoisted_75, _hoisted_78, 512 /* NEED_PATCH */))
        : _createCommentVNode("v-if", true)
    ], 6 /* CLASS, STYLE */)
  ]))
}